export default {
  home: {
    label1: '中文',
    vip: '开通会员', // 开通会员
    Downloadquota: '下载额度', // 下载额度
    Downloadspeed: '下载加速', // 下载加速
    Cloudcapacity: '云盘空间', // 云盘空间
    Cloudequity: '云盘权益', // 云盘权益
    DownloadLimit: '今日下载额度', // 今日下载额度
    awelfarepoint: '福利点', // 福利点
    HelpCentre: '帮助中心', // 帮助中心
    AccountSettings: '账号设置', // 账号设置
    SignOut: '退出登录', // 退出登录
    Login: '登 录', // 登录
    Signup: '注 册', // 注册
    Premium: '开通会员', //开通会员
    PremiumTwo: '升级会员', //升级会员
    PremiumThree: '会员中心', //会员中心
  },
  news: {
    // 信息悬浮框模块
    All: '全部', // 全部
    SystemNotification: '系统通知', // 系统通知
    OfficialNews: '官方消息', // 官方消息
    ReadAll: '全部已读', // 全部已读
    Nonews: '暂无消息', // 暂无消息
  },
  model: {
    mtext1: '该链接由', //该链接由
    mtest2: '自行分享，并不代表本站立场', //自行分享，并不代表本站立场
    report: '举报', //举报
    redirectLink: '跳转链接', //跳转链接
    mtest3: '点击后将跳转至外部网站', //点击后将跳转至外部网站
    mtest4: '该短链已被系统审核过滤或被分享者删除，无法访问', //该短链已被系统审核过滤或被分享者删除，无法访问
    mtest5: '参考资料：', //参考资料：
    mtest6: '如有疑问可访问：', //如有疑问可访问：
    mtest7: '未找到短链页面，请检查短链是否正确', //未找到短链页面，请检查短链是否正确
    mtest8: '《Feemoo内容审核机制公示》', //《Feemoo内容审核机制公示》
    mtest9: '《Feemoo帮助中心》', //《Feemoo帮助中心》
    mtest10: '登录后跳转链接', //登录后跳转链接
    mtest11: '完成登录点击将跳转至外部网站', //完成登录点击将跳转至外部网站
    mtest12: '去小程序看广告后跳转', //去小程序看广告后跳转
    mtest13: '点击后前往微信小程序观看广告后将跳转至外部网站', //点击后前往微信小程序观看广告后将跳转至外部网站
    mtest14: '去APP看广告后跳转', //去APP看广告后跳转
    mtest15: '点击后前往APP观看广告后将跳转至外部网站', //点击后前往APP观看广告后将跳转至外部网站
    SharedLink:'分享的链接',//分享的链接
    UnlockLogin:'登录后解锁',//登录后解锁
    Unlock:'解锁',//解锁
    Open:'打开',//打开
    mtest16:'登录后去小程序看广告解锁',//登录后去小程序看广告解锁
    mtest17:'去小程序看广告解锁',//去小程序看广告解锁
    mtest18:'登录后去APP看广告解锁',//登录后去APP看广告解锁
    mtest19:'去APP看广告解锁',//去APP看广告解锁
    mtest20:'登录后点击解锁',//登录后点击解锁
    mtest21:'点击解锁获取链接',//点击解锁获取链接
  },
  homeFirst: {
    Quicktools: '快捷功能', // 快捷功能
    Files: '文件',
    Share: '分享',
    Set: '合集',
    DeepSeek: 'DeepSeek',
    Unzip: '云解压',
    Transit: '云转存',
    Record: '下载历史',
    Device: '设备管理',
    Collect: '收藏',
    Activity: '动态',
    MoreActivity: '查看更多动态',
    recycle: '回收站', // 回收站
    ShortLink: '短链', // 短链
    ThisMonth: '本月',
    LastMonths: '近三个月',
    DownloadLimit: '今日下载额度', // 今日下载额度
    Downloadspeed: '下载加速', // 下载加速
    awelfarepoint: '福利点', // 福利点
    welfare: '福利社',// 福利社
  },
}
